export default __webpack_public_path__ + "static/media/trus21.5d203089.png";